﻿import global from '../../../../../shared/utils/global.js';
import { WebSocketService } from '../../../../../services/websocketservice.js';
import { setDriverUnit } from '../../../../auth/views/login/auth.api.js';
import { formatTime } from '../../../../../shared/utils/timeformats.js';
import { formatCoordinate, getAddressFromCoordinates } from '../../../../../shared/utils/coordinateformats.js';
import { deleteTruck, deleteTrailer } from './repeaters/units.api.js';
import { fetchRepeaters } from './repeaters/repeaters.api.js';
import { getImeiTruck, getTrailer, getUnits, getTrailers } from '../handleunitdata.js';
import { deleteRepeaters } from './repeaters/handlerepeaterdata.js';
import { displayMainPane } from '../main/mainpage.js';
import { getUnitGroupName } from '../groups/unitgroupsview.js';
import { displayUnitInfo, showUnitOnMap } from '../unitinfo/unitinfo.js';
import { openUnitConfigForm } from './repeaters/unitconfig.js';
import { createDiagramView, displaySensorUpdates } from './sensors/unitdiagrams.js';


import { hideLoading } from '../../../../../shared/components/modal.js';
const wsService = new WebSocketService();

export const displayDetailPanes = async () => {
  initDetailPageListeners();
  const units = await getUnits();
  const selectedUnitId = global.selectedUnitId;
  const previousSelectedUnit = global.selectedUnit;

  let selectedUnit = null;

  if (selectedUnitId) {
    selectedUnit = units.find(u => u.unitId === selectedUnitId);
  }

  if (!selectedUnit && previousSelectedUnit) {
    selectedUnit = units.find(u => u.unitId === previousSelectedUnit.unitId) ||
      units.find(u => u.imei === previousSelectedUnit.imei);
  }

  if (!selectedUnit && units.length > 0) {
    selectedUnit = units[0]; // fallback to first available unit
  }

  if (!selectedUnit) {
    console.warn('No unit available to display');
    return;
  }

  global.selectedUnit = selectedUnit;
  global.selectedUnitId = selectedUnit.unitId;

  getSensorUpdates(); // relies on global.selectedUnit
  setDetailInterval(selectedUnit);
  displayUnitDetail('UNIT', units, selectedUnit);
};

export const displayUnitsListTrailersOnly = async () => {
  try {

    const units = await getUnits();
    const trailers = [
      ...units.filter(unit => unit.unitType === 'TRAILER' || unit.type === 'trailer'),
      ...units.flatMap(unit => unit.trailers || [])
    ];

    let selectedUnit = global.selectedUnit;
    if (selectedUnit && selectedUnit.trailers) {
      selectedUnit = selectedUnit.trailers[0];
      global.selectedUnit = selectedUnit;
    }
    getSensorUpdates();
    setDetailInterval(selectedUnit);
    if (trailers.length > 0) {
      //selectedUnit = units.find(u => u.unitId === selectedUnit.unitId);
      if (!selectedUnit) {
        selectedUnit = trailers[0];
        global.selectedUnit = selectedUnit;
      }
      displayUnitDetail('TRAILER', trailers, selectedUnit);
    } else {
      let unitsListContainer = document.getElementById('unitslistcontainer');
      while (unitsListContainer.hasChildNodes()) {
        unitsListContainer.removeChild(unitsListContainer.lastChild);
      }
      let unitDiagrams = document.getElementsByClassName('unitbox');
      while (unitDiagrams.length > 0) {
        unitDiagrams[0].remove();
      }
      selectedUnit = null;
    }
  }
  catch (e) {
    console.error("detailpageJS - displayUnitsListTrailersOnly: " + e.message);
    global.selectedUnit = null;
    return;
  }
};

export function displayTrailerDetail(trailers, selectedUnit) {

  document.body.style.cursor = 'wait';
  displayUnitsList('TRAILER', trailers, selectedUnit);
  displayDiagramViews(selectedUnit);
  // document.getElementById('detailspane').style.display = 'block';
  // global.showMainPage = false;
  // removeMainPane();
  document.body.style.cursor = 'default';
}

export async function setDetailInterval(unit) {

  if (global.detailIntervalId) {
    clearInterval(global.detailIntervalId);
  }

  global.detailIntervalId = setInterval(async () => {
    const units = await getUnits();
    const selectedUnit = units.find(u => u.unitId === unit.unitId); //unit's fresh data from getUnits
    updateDisplayedUnit(selectedUnit).catch((error) => {
      //logMessage(`${error} Error detail in console`);
      console.log("detailpageJS: setDetailInterval - ERROR " + error + ")");
      console.error(error);
    });
  }, 300000); //5 minutes: 1 minute = 60,000 milliseconds; 5 minutes = 5 * 60000 = 300000 milliseconds;  
}

export function getSensorUpdates() {
  try {

    stopSensorUpdates();

    wsService.connect('sensorUpdates');

    let lastReceivedMessageId = null;
    wsService.addEventListener('message', (event) => {
      const data = event.detail;
      const unit = global.selectedUnit;
      // Ensuring messages are not duplicated
      if (data && data.imei === unit.imei) {
        const dataId = `${data.imei}${data.wheelSensorUID}${data.payloadTS}`;
        if (dataId !== lastReceivedMessageId) { // Assuming 'id' or a unique field is available
          lastReceivedMessageId = dataId;
          console.log('Received message for detail page:', data);
          displaySensorUpdates(unit, data);
        } else {
          console.log('Duplicate message ignored:', data);
        }
      }
    });

    window.addEventListener('unload', () => {
      wsService.disconnect();
    });
  } catch (e) {
    console.error('detailpageJS (getSensorUpdates): WebSocket - ERROR: ', e);
  }
}

export function stopSensorUpdates() {
  try {

    wsService.removeListeners(); // Remove all event listeners
    wsService.disconnect(); // Ensure any previous connection is closed        

  } catch (e) {
    console.error('detailpageJS (stopSensorUpdates): WebSocket - ERROR: ', e);
  }
}

export async function updateDisplayedUnit(selectedUnit) {

  if (!selectedUnit) return;

  global.selectedUnit = selectedUnit;

  const hasLocation =
    selectedUnit.location &&
    selectedUnit.location.latitude !== undefined &&
    selectedUnit.location.longitude !== undefined;

  if (hasLocation && document.getElementById(`unitinfotimeupdated${selectedUnit.imei}`)) {
    document.getElementById(`unitinfotimeupdated${selectedUnit.imei}`).innerText = `Time Updated: ${selectedUnit.timeUpdated}`;
    const address = await getAddressFromCoordinates(selectedUnit.location.latitude, selectedUnit.location.longitude);
    document.getElementById(`unitinfolocation${selectedUnit.imei}`).innerText = `Location: ${address}`;
    document.getElementById(`unitinfospeed${selectedUnit.imei}`).innerText = `Speed: ${selectedUnit.speed} km/h`;
    const location = {
      longitude: formatCoordinate(selectedUnit.location.longitude),
      latitude: formatCoordinate(selectedUnit.location.latitude)
    };
    showUnitOnMap(location);
  }

  const sensors = [
    ...(selectedUnit.wheelSensors || []),
    ...(selectedUnit.spareSensors || []),
    ...(selectedUnit.unpairedSensors || [])
  ];
  for (let s = 0; s < sensors.length; s++) {

    const now = new Date();
    const currentTimeFormatted =
      `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;

    const payloadTS = sensors[s]?.payloadTS ? new Date(sensors[s].payloadTS) : null;

    // Format payloadTS in the same way as currentTimeFormatted
    const payloadTimeFormatted = payloadTS
      ? `${payloadTS.getHours().toString().padStart(2, '0')}:${payloadTS.getMinutes().toString().padStart(2, '0')}:${payloadTS.getSeconds().toString().padStart(2, '0')}`
      : currentTimeFormatted;

    if (document.getElementById(`sv${sensors[s].Id}timeupdated`)) {
      document.getElementById(`sv${sensors[s].Id}timeupdated`).innerText = payloadTimeFormatted;
    }
    if (document.getElementById(`sv${sensors[s].Id}sensorid`)) {
      document.getElementById(`sv${sensors[s].Id}sensorid`).innerText = sensors[s].id;
    }
    if (document.getElementById(`sv${sensors[s].Id}tyreid`)) {
      document.getElementById(`sv${sensors[s].Id}tyreid`).innerText = `${sensors[s]?.tyre?.externalTyreId}` || '-';
    }
    if (document.getElementById(`sv${sensors[s].Id}treaddepth`)) {
      document.getElementById(`sv${sensors[s].Id}treaddepth`).innerText = sensors[s]?.tyre?.tyreTreadDepth > 0 ? `${sensors[s]?.tyre?.tyreTreadDepth} mm` : '-';
    }
    if (document.getElementById(`sv${sensors[s].Id}rotation`)) {
      const sensor = sensors[s];
      const sensorId = sensor?.sensorId ?? sensor?.Id;
      const rotationElement = sensorId
        ? document.getElementById(`sv${sensorId}rotation`)
        : null;

      if (rotationElement) {
        const rotation = parseInt(sensor.currentRotation, 10);

        if (rotation === -107) {
          rotationElement.innerText = "Sensor Failed";
          rotationElement.className = "sensorvalues red";
        } else if (Number.isFinite(rotation) && Math.abs(rotation) < 1000) {
          rotationElement.innerText = "Stopped";
          rotationElement.className = "sensorvalues green";
        } else if (Number.isFinite(rotation)) {
          rotationElement.innerText = "Rolling";
          rotationElement.className = "sensorvalues signalgreen";
        } else {
          rotationElement.innerText = "-";
        }
      }
    }
  }
}

const removeMainPane = () => {

  const unitsListMain = document.getElementById('unitslistmain');
  while (unitsListMain.hasChildNodes()) {
    unitsListMain.removeChild(unitsListMain.lastChild);
  }
  unitsListMain.style.display = "none";

  const mainPane = document.getElementById('mainpane');
  mainPane.style.display = "none";
};

// Helper to clear children (assuming it's defined globally or accessible)
const clearChildren = (element) => {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
};

// ... (previous helper functions and displayMainUnitsGroupsList code)

function displayUnitsList(unitType, units, selectedUnit) { // 'selectedUnit' is the unit that *should* be initially displayed
  try {
    let unitsListDiv = document.getElementById('unitslist');
    clearChildren(unitsListDiv); // Clear existing content

    let unitsListFragment = document.createDocumentFragment();

    let displayUnits = [...units];
    if (!global.mainUnitsListSelected) {
      displayUnits = global.selectedGroupUnits?.length ? global.selectedGroupUnits : [...units];
      let groupNameDiv = document.createElement('div');
      let selectedGroupName = getUnitGroupName(); // Assuming this function exists and returns the group name
      // Ensure unique ID for groupNameDiv if group names can repeat, otherwise remove ID
      groupNameDiv.id = selectedGroupName; // Be cautious: If groupName is not unique, this will cause issues.
      let groupNameDivClasses = ['unitgroupcenter'];
      groupNameDiv.classList.add(...groupNameDivClasses);

      groupNameDiv.innerHTML = selectedGroupName;
      unitsListFragment.appendChild(groupNameDiv);

      // groupNameDiv.onclick = (e) => {
      //     e.stopImmediatePropagation();
      //     global.mainUnitsListSelected = false;
      //     displayMainPane(units); // Navigate back to main pane
      // };
    }

    let unitsListContainerDiv = createUnitsListContainer(); // Assuming this creates the container for individual unit divs
    unitsListFragment.appendChild(unitsListContainerDiv);
    unitsListDiv.appendChild(unitsListFragment); // Append the main container and group name to the DOM

    // --- Crucial modification for initial display ---
    // Set the global selected unit right at the beginning of rendering the list.
    // This ensures the `onclick` handler's logic (which relies on `global.selectedUnit`)
    // has the correct initial state.
    global.selectedUnit = selectedUnit;

    for (let i = 0; i < displayUnits.length; i++) {
      let u = displayUnits[i]; // 'u' is the unit object for the current div being created in the list

      let unitDiv = createUnitContainer(unitType, u); // Assuming this creates the individual unit's div
      unitDiv.id = `unit${u.unitId}`; // Assign a unique ID to the unitDiv for reliable lookup
      unitsListContainerDiv.appendChild(unitDiv);

      // Highlight the unitDiv if it matches the 'selectedUnit' that was passed into the function
      // This handles both primary units and linked trailers correctly because
      // 'selectedUnit' now has the 'unitId' property consistently (as per previous refactor).
      if (selectedUnit && selectedUnit.unitId === u.unitId) {
        unitDiv.classList.add('selectedunit');
      }
      // If you also want to highlight the parent truck if a linked trailer is selected, add:
      // else if (selectedUnit && selectedUnit.isLinkedTrailer && u.unitId === selectedUnit.parentTruck?.unitId) {
      //     unitDiv.classList.add('selectedunit');
      // }

      // --- Existing onclick handler logic (already refactored in previous iteration) ---
      unitDiv.onclick = async (e) => {
        e.stopImmediatePropagation();

        const clickedUnit = u; // The unit object associated with this clicked div
        const clickedUnitId = clickedUnit.unitId;

        // References to the DOM elements for info panes
        const currentlyOpenPane = document.getElementById(`unitinfo${global.selectedUnit?.unitId}`); // Pane for the globally selected unit
        const clickedUnitPane = document.getElementById(`unitinfo${clickedUnitId}`); // Pane for the unit just clicked

        // Scenario 1: Clicking the unit that is currently globally selected (to close its pane)
        if (global.selectedUnit && global.selectedUnit.unitId === clickedUnitId) {
          if (clickedUnitPane && clickedUnitPane.hasChildNodes()) {
            clearChildren(clickedUnitPane); // Close the clicked unit's info pane
          }
          unitDiv.classList.remove('selectedunit'); // Remove 'selectedunit' class from this div
          global.selectedUnit = null; // Important: Clear the globally selected unit state

          // Clear/reset any other elements/data that depend on a unit being selected
          displayDiagramViews(null); // Clear diagram view
          updateDisplayedUnit(null); // Clear any displayed unit info
          setDetailInterval(null); // Clear interval for unit details
        }
        // Scenario 2: Clicking a different unit (close previous pane, open new one)
        else {
          // Step A: Close the previously open pane (if any) and remove its active class
          if (currentlyOpenPane && currentlyOpenPane.hasChildNodes()) {
            clearChildren(currentlyOpenPane);
            // Find the div element for the previously selected unit to remove its class
            const prevUnitDivElement = document.getElementById(`unit${global.selectedUnit.unitId}`);
            if (prevUnitDivElement) {
              prevUnitDivElement.classList.remove('selectedunit');
            }
          }

          // Step B: Fetch fresh data for the newly clicked unit before displaying details
          let unitDataToDisplay = clickedUnit; // Start with the data from the list
          try {
            const allUnitsFresh = await getUnits(); // Get latest data for all units
            const foundFreshUnit = allUnitsFresh.find(unit => unit.unitId === clickedUnitId);

            if (foundFreshUnit) {
              unitDataToDisplay = foundFreshUnit; // Use fresh data if found as a primary unit
            } else if (clickedUnit.isLinkedTrailer && clickedUnit.parentTruck) {
              // If the clicked unit is a linked trailer, try to find its refreshed parent truck
              const freshParentTruck = allUnitsFresh.find(unit => unit.unitId === clickedUnit.parentTruck.unitId);
              if (freshParentTruck && freshParentTruck.trailers) {
                const freshLinkedTrailer = freshParentTruck.trailers.find(t => t.Id === clickedUnit.Id);
                if (freshLinkedTrailer) {
                  unitDataToDisplay = {
                    ...freshLinkedTrailer,
                    unitId: freshLinkedTrailer.Id, // Ensure unitId is present for consistency
                    isLinkedTrailer: true,
                    parentTruck: freshParentTruck
                  };
                }
              }
            }
          } catch (fetchError) {
            console.error("Failed to fetch fresh unit data for details:", fetchError);
            // Log the error but continue with the existing `clickedUnit` data
          }

          // Step C: Open the newly clicked unit's info pane and set its active class
          if (clickedUnitId) displayUnitInfo(unitDataToDisplay); // Display details
          unitDiv.classList.add('selectedunit'); // Add 'selectedunit' class to the current div
          global.selectedUnit = unitDataToDisplay; // Important: Set the globally selected unit state

          // Step D: Call other display functions that depend on the selected unit
          displayDiagramViews(global.selectedUnit);
          updateDisplayedUnit(global.selectedUnit);
          getSensorUpdates(); // This likely uses global.selectedUnit
          setDetailInterval(global.selectedUnit);
        }
      };
    } // --- End of for loop ---

    // --- NEW: Trigger display for the initially selected unit AFTER all divs are rendered ---
    // This ensures the unit's info pane is displayed when the page first loads
    // if `selectedUnit` was provided from the 'previous page'.
    if (selectedUnit && selectedUnit.unitId) { // Check if a valid selectedUnit was passed
      // The global.selectedUnit is already set above, so these calls will use it.
      // No need to fetch fresh data again here, as that happened in the onclick handler for 'displayMainUnitsGroupsList'.
      displayUnitInfo(selectedUnit); // Display info for the initially selected unit
      displayDiagramViews(selectedUnit);
      updateDisplayedUnit(selectedUnit);
      getSensorUpdates(); // Will use global.selectedUnit
      setDetailInterval(selectedUnit);
    } else {
      // If no unit was initially selected, or if the initial selectedUnit was invalid,
      // ensure that other elements that depend on a selected unit are cleared/reset.
      displayDiagramViews(null);
      updateDisplayedUnit(null);
      setDetailInterval(null); // Clear any existing intervals
    }

    hideLoading();
    document.body.style.cursor = 'default';
  } catch (e) {
    console.error(`detailpageJS - displayUnitsList: ${e}`);
    return;
  }
}

// Ensure displayUnitDetail passes the correct unit to displayUnitsList
export async function displayUnitDetail(unitType, units, selectedUnit) {
  document.body.style.cursor = 'wait';
  const userRole = global.userRole;
  if (userRole === 'Driver') {
    await setDriverUnit(selectedUnit?.apiUnitId);
    localStorage.setItem('selectedUnit', selectedUnit.unitId);
    displayDriverUnit(unitType, units, selectedUnit);
  } else {
    // Pass the actual selectedUnit object received from displayMainUnitsGroupsList
    displayUnitsList(unitType, units, selectedUnit);
  }

  displayDiagramViews(selectedUnit);
  document.getElementById('detailspane').style.display = 'flex';
  global.showMainPage = false;
  removeMainPane();
  document.body.style.cursor = 'default';
}

export async function displayUnitDetail1(unitType, units, selectedUnit) {

  document.body.style.cursor = 'wait';
  const userRole = global.userRole;
  if (userRole === 'Driver') {
    await setDriverUnit(selectedUnit?.apiUnitId);
    localStorage.setItem('selectedUnit', selectedUnit.unitId);
    displayDriverUnit(unitType, units, selectedUnit);
  } else {
    displayUnitsList(unitType, units, selectedUnit);
  }

  displayDiagramViews(selectedUnit);
  document.getElementById('detailspane').style.display = 'flex';
  global.showMainPage = false;
  removeMainPane();
  document.body.style.cursor = 'default';
}

const displayDriverUnit = (unitType, units, selectedUnit) => {

  try {
    let unitsListDiv = document.getElementById('unitslist');
    while (unitsListDiv.hasChildNodes()) {
      unitsListDiv.removeChild(unitsListDiv.lastChild);
    }

    let unitsListFragment = document.createDocumentFragment();

    let displayUnit = selectedUnit;
    if (!global.mainUnitsListSelected) {
      displayUnit = global.selectedUnit;
      let groupNameDiv = document.createElement('div');
      let selectedGroupName = getUnitGroupName();
      groupNameDiv.id = selectedGroupName;
      let groupNameDivClasses = ['unitgroupcenter'];
      groupNameDiv.classList.add(...groupNameDivClasses);

      groupNameDiv.innerHTML = selectedGroupName;
      unitsListFragment.appendChild(groupNameDiv);

      // groupNameDiv.onclick = (e) => {
      //     e.stopImmediatePropagation();
      //     global.mainUnitsListSelected = false;
      //     displayMainPane(units);  //***dalk eerder main() hier roep;
      //     //main();
      // };
    }

    let unitsListContainerDiv = createUnitsListContainer();
    unitsListFragment.appendChild(unitsListContainerDiv);
    unitsListDiv.appendChild(unitsListFragment);

    // let selectedUnitInfoDisplayed = true;
    let unitDivClassAdded = false;


    let u = displayUnit;
    let unitDiv = createUnitContainer(unitType, u);
    unitsListContainerDiv.appendChild(unitDiv);

    if (selectedUnit && ((unitType !== 'TRAILER' && selectedUnit.unitId && selectedUnit.unitId === u.unitId)) || selectedUnit.unitId === u.unitId) {
      unitDiv.classList.add('selectedunit');
      unitDiv.selected = true;
      if (selectedUnit.imei) {
        displayUnitInfo(selectedUnit);
      }
    }

    if (selectedUnit && unitType === 'TRAILER' && selectedUnit.imei && selectedUnit.trailers) {
      for (let trailer of selectedUnit.trailers) {
        if (!unitDivClassAdded && trailer.Id === u.Id) {
          selectedUnit = u;
          global.selectedUnit = selectedUnit;
          unitDiv.classList.add('selectedunit');
          unitDivClassAdded = true;
          unitDiv.selected = true;
          displayUnitInfo(selectedUnit);
          break; // Exit the loop once a match is found
        }
      }
    }

    hideLoading();
    document.body.style.cursor = 'default';
  }
  catch (e) {
    console.error(`detailpageJS - displayUnitsList: ${e}`);
    return;
  }
};

function displayUnitsList1(unitType, units, selectedUnit) {

  try {
    let unitsListDiv = document.getElementById('unitslist');
    while (unitsListDiv.hasChildNodes()) {
      unitsListDiv.removeChild(unitsListDiv.lastChild);
    }

    let unitsListFragment = document.createDocumentFragment();

    let displayUnits = [...units];
    if (!global.mainUnitsListSelected) {
      displayUnits = global.selectedGroupUnits?.length ? global.selectedGroupUnits : [...units];
      let groupNameDiv = document.createElement('div');
      let selectedGroupName = getUnitGroupName();
      groupNameDiv.id = selectedGroupName;
      let groupNameDivClasses = ['unitgroupcenter'];
      groupNameDiv.classList.add(...groupNameDivClasses);

      groupNameDiv.innerHTML = selectedGroupName;
      unitsListFragment.appendChild(groupNameDiv);

      // groupNameDiv.onclick = (e) => {
      //     e.stopImmediatePropagation();
      //     global.mainUnitsListSelected = false;
      //     displayMainPane(units);  //***dalk eerder main() hier roep;
      //     //main();
      // };
    }

    let unitsListContainerDiv = createUnitsListContainer();
    unitsListFragment.appendChild(unitsListContainerDiv);
    unitsListDiv.appendChild(unitsListFragment);

    // let selectedUnitInfoDisplayed = true;
    let unitDivClassAdded = false;
    for (let i = 0; i < displayUnits.length; i++) {

      let u = displayUnits[i];

      //const isGroupUnit = false;
      //let unitDiv = createUnitContainer(u, uwt, isGroupUnit);
      let unitDiv = createUnitContainer(unitType, u);
      unitsListContainerDiv.appendChild(unitDiv);

      if (selectedUnit && ((unitType !== 'TRAILER' && selectedUnit.unitId && selectedUnit.unitId === u.unitId)) || selectedUnit.unitId === u.unitId) {
        unitDiv.classList.add('selectedunit');
        unitDiv.selected = true;
        if (selectedUnit.imei) {
          displayUnitInfo(selectedUnit);
        }
      }

      if (selectedUnit && unitType === 'TRAILER' && selectedUnit.imei && selectedUnit.trailers) {
        for (let trailer of selectedUnit.trailers) {
          if (!unitDivClassAdded && trailer.Id === u.Id) {
            selectedUnit = u;
            global.selectedUnit = selectedUnit;
            unitDiv.classList.add('selectedunit');
            unitDivClassAdded = true;
            unitDiv.selected = true;
            displayUnitInfo(selectedUnit);
          }
        }
      }

      unitDiv.onclick = async (e) => {

        e.stopImmediatePropagation();

        const selectedUnitId = u.unitId;

        // Get the div for the currently selected unit's info
        let currentUnitInfoPaneDiv = document.getElementById(`unitinfo${selectedUnitId}`);
        console.log("Selected Unit:", selectedUnitId, "Previous Unit:", global?.selectedUnit?.unitId || 'None');

        // If there is already a selected unit and it's different from the current unit
        if (global?.selectedUnit?.unitId && global?.selectedUnit?.unitId !== selectedUnitId) {
          // Close the previously selected unit's info pane
          let prevUnitInfoPaneDiv = document.getElementById(`unitinfo${global.selectedUnit.unitId}`);
          if (prevUnitInfoPaneDiv && prevUnitInfoPaneDiv.hasChildNodes()) {
            while (prevUnitInfoPaneDiv.hasChildNodes()) {
              prevUnitInfoPaneDiv.removeChild(prevUnitInfoPaneDiv.lastChild);
            }
          }
        }

        // Toggle current unit's info: if open, close it; if closed, open it
        if (currentUnitInfoPaneDiv && currentUnitInfoPaneDiv.hasChildNodes()) {
          // Close the current unit's info pane
          while (currentUnitInfoPaneDiv.hasChildNodes()) {
            currentUnitInfoPaneDiv.removeChild(currentUnitInfoPaneDiv.lastChild);
          }
        } else {
          // Open the current unit's info pane by displaying its details
          if (u.unitId) displayUnitInfo(u);
        }

        // Update the global state with the currently selected unit's ID
        //global.selectedUnit.unitId = selectedUnitId;


        // Ensure the 'selectedunit' class is only applied to the current selected unit
        let selectedUnitContainers = document.getElementsByClassName('selectedunit');
        if (selectedUnitContainers.length > 0) {
          selectedUnitContainers[0].classList.remove('selectedunit');
        }

        // Mark the current unit as the selected unit
        unitDiv.classList.add('selectedunit');

        const units = await getUnits();
        selectedUnit = units.find(unit => unit.unitId === u.unitId);  //unit's fresh data from getUnits
        if (!selectedUnit) selectedUnit = u; //Trailer view = selected trailer might not be part of units
        global.selectedUnit = selectedUnit;

        // Additional logic for displaying diagrams or other unit-related data
        displayDiagramViews(selectedUnit);
        updateDisplayedUnit(selectedUnit);
        getSensorUpdates(); //selectedUnit not always available, have to rely on global
        setDetailInterval(selectedUnit);
      };
    }

    hideLoading();
    document.body.style.cursor = 'default';
  }
  catch (e) {
    console.error(`detailpageJS - displayUnitsList: ${e}`);
    return;
  }
}

export function displayDiagramViews(unit) {
  createDiagramView(unit, 'WHEELSDIAGRAM', 'rightpane');
  if (!global.sensorValuesDiagramDateSelected) {
    createDiagramView(unit, 'SENSORVALUESDIAGRAM', 'middlepane');
  }
}

const createUnitContainer = (unitType, unit) => {

  try {
    let unitDiv = document.createElement('div');
    //if (isGroupUnit) unitDiv.id = `groupunit${unit.imei}`
    //else unitDiv.id = unit.imei;
    unitDiv.id = `unit${unit.unitId}`;
    unitDiv.className = 'unit';
    unitDiv.selected = false;
    //unitDiv.classList.add('selectunit');

    const unitHeaderDiv = document.createElement('div');
    unitHeaderDiv.className = 'unitheader';
    unitDiv.appendChild(unitHeaderDiv);

    // const listIcon = document.createElement('svg');
    // listIcon.className = 'trucktrailer-listicon';
    // unitHeaderDiv.appendChild(listIcon);

    const unitTextSpan = document.createElement('span');
    unitTextSpan.id = `unitheadername${unit.unitId || unit.imei}`;
    unitTextSpan.innerText = unit.name || unit.imei; // Set initial text
    unitHeaderDiv.appendChild(unitTextSpan);

    //Metric flags
    const metricFlagsSpan = document.createElement("span");
    metricFlagsSpan.className = "listspanicons";
    unitHeaderDiv.appendChild(metricFlagsSpan);

    if (unit.yellowFlags > 0) {
      let vspan = document.createElement("span");
      let vtxt = document.createTextNode("V");
      vspan.className += "yellowflag";
      vspan.appendChild(vtxt);
      metricFlagsSpan.appendChild(vspan);
    }
    if (unit.orangeFlags > 0) {
      let tspan = document.createElement("span");
      let ttxt = document.createTextNode("T");
      tspan.className += "orangeflag";
      tspan.appendChild(ttxt);
      metricFlagsSpan.appendChild(tspan);
    }
    if (unit.blinkFlags > 0) {
      let pspan = document.createElement("span");
      let ptxt = document.createTextNode("P");
      pspan.className += "blinkflag";
      pspan.appendChild(ptxt);
      metricFlagsSpan.appendChild(pspan);
    } else {
      if (unit.redFlags > 0) {
        let pspan = document.createElement("span");
        let ptxt = document.createTextNode("P");
        pspan.className += "redflag";
        pspan.appendChild(ptxt);
        metricFlagsSpan.appendChild(pspan);
      }
    }
    if (unit.purpleFlags > 0) {
      let pspan = document.createElement("span");
      let ptxt = document.createTextNode("P");
      pspan.className += "purpleflag";
      pspan.appendChild(ptxt);
      metricFlagsSpan.appendChild(pspan);
    }
    if (unit.grayFlags > 0) {
      let ospan = document.createElement("span");
      let otxt = document.createTextNode("S");
      ospan.className += "blueflag";
      ospan.appendChild(otxt);
      metricFlagsSpan.appendChild(ospan);
    }

    const userRole = global.userRole;
    const serviceAgentAccessLevel = global.serviceAgentAccessLevel;

    if (userRole === 'Administrator' || (userRole === 'ServiceAgent' && serviceAgentAccessLevel === 'Administrator')) {

      const unitEditBtn = document.createElement("button");
      unitEditBtn.classList.add('btn-inline', 'btn-edit-inline');
      unitEditBtn.textContent = 'Edit';
      unitEditBtn.id = unit.unitId ? `edit${unit.unitId}btn` : (unit.imei ? `edit${unit.imei}btn` : 'editunitbtn');
      metricFlagsSpan.appendChild(unitEditBtn);
      unitEditBtn.onclick = async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        let repeaters = [];
        if (unit.imei && !unit.trailerNumber) {
          const truck = await getImeiTruck(unit);
          repeaters = await fetchRepeaters(truck);
          openUnitConfigForm(unit, truck, 'TRUCK', repeaters);
        } else {
          repeaters = await fetchRepeaters();
          try {
            repeaters = repeaters.filter(
              repeater => repeater?.unitName && unit?.name && repeater?.unitName === unit?.name && repeater?.unitType === 'Trailer'
            );
          } catch (error) {
            console.error('Error while filtering repeaters:', error);
            // or handle the fallback logic here
          }
          const trailer = await getTrailer(unit);
          openUnitConfigForm(null, trailer, "TRAILER", repeaters);
        }
      };

      const unitDeleteBtn = document.createElement("button");
      unitDeleteBtn.classList.add('btn-inline', 'btn-delete-inline');
      unitDeleteBtn.textContent = 'Delete';
      unitDeleteBtn.id = unit.unitId ? `delete${unit.unitId}btn` : (unit.imei ? `delete${unit.imei}btn` : 'deleteunitbtn');
      metricFlagsSpan.appendChild(unitDeleteBtn);

      unitDeleteBtn.onclick = async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        let message = 'Are you sure you want to delete this unit?<br><br>';
        let truck, repeaters = [];
        if (unit.imei && !unit.trailerNumber) {
          truck = await getImeiTruck(unit);
          if (truck) {
            message += 'Before deleting a truck, make sure to contact your supplier and cancel your subscription.  If not, you will still be billed for the unit.  ';
            message += 'Once you have canceled your subscription, you can proceed with deleting the truck.<br><br>';
            repeaters = await fetchRepeaters(truck);
            if (repeaters.length > 0) {
              message += 'Please note that this truck has linked trailers that will not be deleted.<br><br>';
            }
            message += 'Do you want to continue?';
          } else {
            message = 'The Truck for this IMEI number is not defined yet.';
            const confirmDeleteBtn = document.getElementById('confirmdeletebtn');
            confirmDeleteBtn.disabled = true;
          }
        }

        document.getElementById('deleteconfirmationmessage').innerHTML = message;
        const deleteConfirmationModal = new bootstrap.Modal(document.getElementById('deleteconfirmationmodal'));
        deleteConfirmationModal.show();

        document.getElementById('confirmdeletebtn').onclick = async () => {
          deleteConfirmationModal.hide();
          try {
            await deleteUnitAndRepeaters(unit, repeaters);
            //remove unit from UI
            displayDetailPanes();
          } catch (error) {
            console.error('Error while deleting fleet asset and repeaters:', error);
            // Handle the error appropriately
          }
        };
      };
    }
    return unitDiv;
  } catch (e) {
    console.log("unitgroupjs - createUnitContainer: " + e.error);
    return;
  }
};

const findRefreshedUnit = (units, detail) => {
  const unitId = detail?.unitId;
  const imei = detail?.imei;

  let refreshedUnit = units.find(unit =>
    unit.unitId === unitId ||
    unit.Id === unitId ||
    unit.imei === imei ||
    unit.IMEI === imei
  );

  if (refreshedUnit) return refreshedUnit;

  for (const parentUnit of units) {
    const trailer = (parentUnit.trailers || []).find(t =>
      t.Id === unitId ||
      t.unitId === unitId ||
      t.imei === imei ||
      t.lastReceivedIMEI === imei
    );

    if (trailer) {
      return {
        ...trailer,
        unitId: trailer.Id || trailer.unitId,
        isLinkedTrailer: true,
        parentTruck: parentUnit
      };
    }
  }

  return null;
};

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const normaliseValue = (value) => String(value ?? '').trim();

const getSensorIdValue = (sensor) =>
  normaliseValue(sensor?.Id ?? sensor?.sensorId ?? sensor?.id);

const getSensorWheelId = (sensor) =>
  normaliseValue(sensor?.wheelId ?? sensor?.tyreId);

const getAllWheelLikeSensors = (unit) => [
  ...(unit?.wheelSensors || []),
  ...(unit?.spareSensors || [])
];

const getAllSensorsForMatching = (unit) => [
  ...(unit?.wheelSensors || []),
  ...(unit?.spareSensors || []),
  ...(unit?.unpairedSensors || [])
];

const sensorMatchesManualRequest = (sensor, request) => {
  return (
    getSensorIdValue(sensor) === normaliseValue(request?.sensorId) &&
    getSensorWheelId(sensor) === normaliseValue(request?.wheelId)
  );
};

const unitHasExpectedManualPairings = (unit, detail) => {
  const requests = detail?.manualPairingRequests || [];

  if (!requests.length) {
    return true;
  }

  const sensors = getAllWheelLikeSensors(unit);

  return requests.every(request =>
    sensors.some(sensor => sensorMatchesManualRequest(sensor, request))
  );
};

const createManualPairingPlaceholderSensor = (request, existingSensor = null) => {
  const sensorId = Number(request.sensorId);
  const wheelId = String(request.wheelId);

  return {
    ...(existingSensor || {}),

    Id: Number.isNaN(sensorId) ? request.sensorId : sensorId,
    id: Number.isNaN(sensorId) ? request.sensorId : sensorId,
    sensorId: Number.isNaN(sensorId) ? request.sensorId : sensorId,

    wheelId,
    tyreId: wheelId,

    manualPairing: true,
    signal: existingSensor?.signal ?? false,
    source: existingSensor?.source || 'ManualPairingRefresh',

    currentPressure: existingSensor?.currentPressure ?? null,
    currentTemperature: existingSensor?.currentTemperature ?? null,
    currentVoltage: existingSensor?.currentVoltage ?? null,
    currentRotation: existingSensor?.currentRotation ?? null,
    payloadTS: existingSensor?.payloadTS ?? null
  };
};

const applyManualPairingRequestsToUnit = (unit, detail) => {
  const requests = detail?.manualPairingRequests || [];

  if (!unit || !requests.length) {
    return unit;
  }

  const patchedUnit = {
    ...unit,
    wheelSensors: [...(unit.wheelSensors || [])],
    spareSensors: [...(unit.spareSensors || [])],
    unpairedSensors: [...(unit.unpairedSensors || [])]
  };

  requests.forEach(request => {
    const requestSensorId = normaliseValue(request.sensorId);
    const requestWheelId = normaliseValue(request.wheelId);
    const axleNumber = parseInt(requestWheelId.slice(1, 3), 10);
    const isSpareWheel = axleNumber === 17;

    const existingSensor = getAllSensorsForMatching(patchedUnit).find(sensor =>
      getSensorIdValue(sensor) === requestSensorId
    );

    const removeSameSensorOrWheel = (sensors) =>
      (sensors || []).filter(sensor =>
        getSensorIdValue(sensor) !== requestSensorId &&
        getSensorWheelId(sensor) !== requestWheelId
      );

    patchedUnit.wheelSensors = removeSameSensorOrWheel(patchedUnit.wheelSensors);
    patchedUnit.spareSensors = removeSameSensorOrWheel(patchedUnit.spareSensors);
    patchedUnit.unpairedSensors = removeSameSensorOrWheel(patchedUnit.unpairedSensors);

    const patchedSensor = createManualPairingPlaceholderSensor(request, existingSensor);

    if (isSpareWheel) {
      patchedUnit.spareSensors.push(patchedSensor);
    } else {
      patchedUnit.wheelSensors.push(patchedSensor);
    }
  });

  // Important: unitdiagrams.js may reuse unit.unitConfig if it already exists.
  // Clearing it forces the diagram to rebuild config from wheelSensors.
  patchedUnit.unitConfig = [];

  return patchedUnit;
};

const getRefreshedUnitWithRetry = async (detail, maxAttempts = 4, delayMs = 600) => {
  let lastFoundUnit = null;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    const units = await getUnits();
    const refreshedUnit = findRefreshedUnit(units, detail);

    console.log(`Refresh after config save attempt ${attempt}:`, {
      found: !!refreshedUnit,
      wheelSensors: refreshedUnit?.wheelSensors?.length || 0,
      expectedPairings: detail?.manualPairingRequests?.length || 0,
      hasExpectedPairings: refreshedUnit
        ? unitHasExpectedManualPairings(refreshedUnit, detail)
        : false
    });

    if (refreshedUnit) {
      lastFoundUnit = refreshedUnit;

      if (unitHasExpectedManualPairings(refreshedUnit, detail)) {
        return refreshedUnit;
      }
    }

    await sleep(delayMs);
  }

  return lastFoundUnit;
};

const renderRefreshedSelectedUnit = async (unit) => {
  if (!unit) return;

  global.selectedUnit = unit;
  global.selectedUnitId = unit.unitId;

  // Redraw the important panes FIRST.
  // This must not depend on the left unit info pane existing.
  displayDiagramViews(unit);

  // Update the left info pane only if its container exists.
  // displayUnitInfo() expects the unitinfo container to exist,
  // so do not call it blindly.
  const unitInfoPane = document.getElementById(`unitinfo${unit.unitId}`);

  if (unitInfoPane) {
    clearChildren(unitInfoPane);

    try {
      displayUnitInfo(unit);
    } catch (error) {
      console.warn('Could not refresh unit info pane after config save:', error);
    }
  } else {
    console.warn(
      `Unit info pane unitinfo${unit.unitId} was not found. Skipping left pane refresh, but diagrams were refreshed.`
    );
  }

  if (!global.sensorValuesDiagramDateSelected) {
    try {
      await updateDisplayedUnit(unit);
    } catch (error) {
      console.warn('Could not update live displayed unit values after config save:', error);
    }
  }

  getSensorUpdates();
  setDetailInterval(unit);
};

const refreshSelectedUnitAfterConfigSave = async (event) => {
  try {
    document.body.style.cursor = 'wait';

    const refreshedUnit = await getRefreshedUnitWithRetry(event.detail);

    if (!refreshedUnit) {
      console.warn('Could not find refreshed unit after config save:', event.detail);
      return;
    }

    const backendAlreadyFresh = unitHasExpectedManualPairings(refreshedUnit, event.detail);

    const unitToRender = backendAlreadyFresh
      ? refreshedUnit
      : applyManualPairingRequestsToUnit(refreshedUnit, event.detail);

    // Always bust the cached unitConfig so ensureDiagramUnitConfig
    // rebuilds from the new wheelSensors, regardless of which path we took.
    unitToRender.unitConfig = [];

    await renderRefreshedSelectedUnit(unitToRender);

    if (!backendAlreadyFresh) {
      setTimeout(async () => {
        const finalUnit = await getRefreshedUnitWithRetry(event.detail, 8, 1000);
        if (finalUnit && unitHasExpectedManualPairings(finalUnit, event.detail)) {
          finalUnit.unitConfig = [];
          await renderRefreshedSelectedUnit(finalUnit);
        }
      }, 1500);
    }

  } catch (error) {
    console.error('Failed to refresh detail panes after unit config save:', error);
  } finally {
    document.body.style.cursor = 'default';
  }
};

async function deleteUnitAndRepeaters(unit, repeaters) {
  if (unit.imei && !unit.trailerNumber) {
    await deleteTruck(unit.customerId, unit.unitId);
    await deleteRepeaters(unit.customerId, repeaters);
  } else {
    repeaters = await fetchRepeaters();
    repeaters = repeaters.filter(
      repeater => repeater?.unitName && unit?.name && repeater?.unitName === unit?.name && repeater?.unitType === 'Trailer'
    );
    await deleteTrailer(unit.customerId, unit.unitId);
    await deleteRepeaters(unit.customerId, repeaters);
  }
}

const createUnitsListContainer = () => {

  let unitsListContainerDiv = document.createElement('div');
  unitsListContainerDiv.id = 'unitslistcontainer';
  unitsListContainerDiv.className = 'unitslistcontainer';
  if (!global.mainUnitsListSelected) {
    unitsListContainerDiv.classList.add('unitsgrouplistcontainer');
  }

  return unitsListContainerDiv;
};

// detailpage.js — replace the bottom guard block with this:
export const initDetailPageListeners = () => {
  if (!window.__pressureTrackUnitConfigSavedListenerAttached) {
    window.addEventListener('pressuretrack:unit-config-saved', refreshSelectedUnitAfterConfigSave);
    window.__pressureTrackUnitConfigSavedListenerAttached = true;
  }
};